import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import LinkIcon from "@mui/icons-material/Link";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import React from "react";
import { useContentStore } from "../../stores/contentStore";
import { locale } from "../../utils/LocaleManager";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";

const ThumbnailMenu = (props: any) => {
  const selectedThumbnails = useContentStore(
    (state: any) => state.selectedThumbnails,
  );
  const setSelectedThumbnails = useContentStore(
    (state: any) => state.setSelectedThumbnails,
  );
  const setIsShowDeleteDialog = useContentStore(
    (state: any) => state.setIsShowDeleteDialog,
  );
  const setIsShowRetagDialog = useContentStore(
    (state: any) => state.setIsShowRetagDialog,
  );
  const rolePermissions = useRolePermissionsStore(
    (state: any) => state.rolePermissions,
  );

  const menuItemsIfMultiple = [
    {
      key: "download",
      icon: <FileDownloadOutlinedIcon fontSize="small" />,
      text: locale.control_download,
      onClick: () => {
        props?.setOpen(false);
        props.onDownload();
      },
    },
    {
      isDivider: true,
      key: "divider-3",
    },
    {
      key: "move",
      icon: <DriveFileMoveOutlinedIcon fontSize="small" />,
      text: locale.control_move,
      onClick: () => {
        props?.setOpen(false);
        props.onClickMove();
      },
      disabled: !rolePermissions?.video?.move,
    },
    {
      key: "add-tag",
      icon: <AddIcon fontSize="small" />,
      text: locale.add_tag,
      onClick: () => {
        props?.setOpen(false);
        setIsShowRetagDialog(true);
      },
    },
    {
      key: "delete",
      icon: <DeleteOutlineOutlinedIcon fontSize="small" />,
      text: locale.control_delete,
      onClick: () => {
        props?.setOpen(false);
        setIsShowDeleteDialog(true);
      },
    },
  ];

  const menuItemsIfSingle = [
    {
      key: "play",
      icon: <PlayCircleOutlineIcon fontSize="small" />,
      text: locale.control_play,
      onClick: () => {
        props?.setOpen(false);
        props?.setSelected(true);
        props.onClickPlay();
      },
    },
    {
      isDivider: true,
      key: "divider-0",
    },
    {
      key: "copy",
      icon: <LinkIcon fontSize="small" />,
      text: locale.control_copy,
      onClick: () => {
        props?.setOpen(false);
        props?.setSelected(true);
        props.onCopyLinks();
      },
    },
    {
      key: "download",
      icon: <FileDownloadOutlinedIcon fontSize="small" />,
      text: locale.control_download,
      onClick: () => {
        props?.setOpen(false);
        props.onDownload();
      },
    },
    {
      key: "details",
      icon: <InfoOutlinedIcon fontSize="small" />,
      text: locale.control_details,
      onClick: () => {
        props?.setOpen(false);
        props.onClickDetails();
      },
    },
    {
      isDivider: true,
      key: "divider-1",
    },
    {
      key: "move",
      icon: <DriveFileMoveOutlinedIcon fontSize="small" />,
      text: locale.control_move,
      onClick: () => {
        props?.setOpen(false);
        props.onClickMove();
      },
      disabled: !rolePermissions?.video?.move,
    },
    {
      key: "rename-tag",
      icon: <DriveFileRenameOutlineOutlinedIcon fontSize="small" />,
      text: locale.control_rename,
      onClick: () => {
        props?.setOpen(false);
        // setIsShowRetagDialog(true);
      },
    },
    {
      key: "delete",
      icon: <DeleteOutlineOutlinedIcon fontSize="small" />,
      text: locale.control_delete,
      onClick: () => {
        props?.setOpen(false);
        setIsShowDeleteDialog(true);
      },
    },
    {
      isDivider: true,
      key: "divider-2",
    },
    {
      key: "add-tag",
      icon: <AddIcon fontSize="small" />,
      text: locale.add_tag,
      onClick: () => {
        props?.setOpen(false);
        setIsShowRetagDialog(true);
      },
    },
    {
      key: "export-tag",
      icon: <IosShareOutlinedIcon fontSize="small" />,
      text: locale.exportTranscript,
      onClick: () => {
        props?.setOpen(false);
        setIsShowRetagDialog(true);
      },
    },
  ];

  const menuItemsIfManage = [
    {
      key: "retag",
      icon: <RefreshIcon fontSize="small" />,
      text: locale.control_retag,
      onClick: () => {
        props?.setOpen(false);
        props?.onRetag();
      },
    },
    {
      key: "delete",
      icon: <DeleteOutlineOutlinedIcon fontSize="small" />,
      text: locale.control_delete_video,
      onClick: () => {
        props?.setOpen(false);
        setIsShowDeleteDialog(true);
      },
    },
  ];

  const renderMenuItem = (item: any) => {
    if (item.isDivider) {
      return <Divider key={item.key} />;
    }

    return (
      <MenuItem
        key={item.key}
        onClick={item.onClick}
        disabled={item.disabled ? item.disabled : false}
      >
        <ListItemIcon>{item.icon}</ListItemIcon>
        <ListItemText>{item.text}</ListItemText>
      </MenuItem>
    );
  };

  const renderThumbnailMenus = () => {
    if (props?.isMultiple) {
      return menuItemsIfMultiple.map((item: any) => renderMenuItem(item));
    }

    return menuItemsIfSingle.map((item: any) => renderMenuItem(item));
  };

  return (
    <Menu
      anchorEl={props?.anchorEl}
      open={props?.open}
      onClose={() => {
        props?.setOpen(false);
        setSelectedThumbnails(
          selectedThumbnails.filter(
            (thumbnail: any) => thumbnail.videoIndexId !== props.videoIndexId,
          ),
        );
        if (!props.isMultiple) {
          props?.setSelected(false);
          setSelectedThumbnails([]);
        }
      }}
      anchorReference={props?.contextMenu ? "anchorPosition" : "anchorEl"}
      anchorPosition={
        props?.contextMenu !== null
          ? {
              top: props?.contextMenu.mouseY,
              left: props?.contextMenu.mouseX,
            }
          : undefined
      }
      slotProps={{ paper: { sx: { width: 250 } } }}
    >
      {!props.isManage ? (
        renderThumbnailMenus()
      ) : (
        menuItemsIfManage.map((item: any) => renderMenuItem(item))
      )}
    </Menu>
  );
};

export default ThumbnailMenu;
